<template>
    <Accordion>
        <AccordionItem v-for="(item, index) in data" :key="`item-${index}`">
            <template slot="accordion-trigger">
                <h3>{{ item.title }}</h3>
            </template>
            <template slot="accordion-content">
                <li>{{ item.content }}</li>
            </template>
        </AccordionItem>
    </Accordion>
</template>

<script>
import VueTypes from 'vue-types';
import Accordion from './accordion.vue';
import AccordionItem from './accordion-item.vue';

export default {
    name: 'LsAccordion',
    components: {
        Accordion,
        AccordionItem,
    },
    props: {
        data: VueTypes.arrayOf(
            VueTypes.shape({
                title: VueTypes.string.isRequired,
                content: VueTypes.string.isRequired,
            }).isRequired
        ).isRequired,
    },
};
</script>

<style lang="scss" scoped>
.accordion__trigger {
    h3 {
        font-size: 12pt;
        font-weight: normal;
        padding-bottom: 12px;
    }
}
</style>
